<template>
	<sideNav :page-title="pageTitle"></sideNav>
	<div v-show="showFlag">
		<div class="ld-panel-title">
			<router-link to="/verify" class="back-btn"><span></span>企业认证</router-link>
		</div>
		<div class="ld-panel-main">
			<el-steps :active="1" finish-status="success" simple style="margin-bottom: 30px;">
			    <el-step title="上传证件照片" />
			    <el-step title="确认并完善信息" />
				<el-step title="客服转账验证" />
				<el-step title="实名认证完成" />
			</el-steps>
			<el-alert title="审核失败原因：" type="error" :closable="false" effect="dark" show-icon style="margin-bottom: 30px;" v-if="businessStatus == '3'">
				<template #default><p>{{authRemark}}</p></template>
			</el-alert>
			<el-form :rules="rules" ref="ruleFormRef" :model="groupForm" :label-width="formLabelWidth">
				<el-form-item label="手机号码" :rules="[{ required: true,message: '',trigger: 'blur'}]">
					<el-input v-model="mobile" disabled autocomplete="off" />
					<router-link to="/account/mobile" style="margin-left: 10px;">修改</router-link>
				</el-form-item>
				<p class="form-tip" style="margin-left: 200px;">请确认该手机号是<el-text type="warning">您本人所有</el-text>，否则无法验证通过！</p>
				<el-form-item label="邮箱号码" :rules="[{ required: true,message: '',trigger: 'blur'}]">
					<el-input v-model="email" disabled autocomplete="off" />
					<router-link to="/account/email" style="margin-left: 10px;">修改</router-link>
				</el-form-item>
				<el-form-item label="密保问题" :rules="[{ required: true,message: '',trigger: 'blur'}]">
					<div v-if="checkQuestion">
						<el-tag type="success">已设置</el-tag>
						<router-link to="/account/email" style="margin-left: 10px;">修改</router-link>
					</div>
					<div v-else>
						<el-tag type="success">未设置</el-tag>
						<router-link to="/account/protection" style="margin-left: 10px;">立即启用</router-link>
					</div>
				</el-form-item>
				<el-form-item label="企业名称" :rules="[{ required: true,message: '',trigger: 'blur'}]">
					<el-input v-model="companyName" disabled autocomplete="off" />
					<router-link to="/verify/business" style="margin-left: 10px;">修改</router-link>
				</el-form-item>
				<el-form-item label="统一社会信用代码" :rules="[{ required: true,message: '',trigger: 'blur'}]">
					<el-input v-model="businessLicence" disabled autocomplete="off" />
				</el-form-item>
				<div v-if="businessStatus == '3'">
					<el-form-item label="营业执照">
						<el-image :src="groupForm.businessLicenceImgUrl" fit="scale-down" preview-teleported :preview-src-list="[groupForm.businessLicenceImgUrl]" style="width: 145px;height:145px" />
					</el-form-item>
					<el-form-item label="法人身份证(头像面)">
						<el-image :src="groupForm.IDCardImgFrontUrl" fit="scale-down" preview-teleported :preview-src-list="[groupForm.IDCardImgFrontUrl]" style="width: 145px;height:145px" />
					</el-form-item>
				</div>
				<el-form-item label="责任人" prop="IDCard">
					<div>姓名<el-input v-model="companyTrueName" disabled autocomplete="off" style="width: 70%; margin-left: 5px;" /></div>
					<div>身份证号码<el-input v-model="groupForm.IDCard" autocomplete="off" style="width: 60%;margin-left: 5px;" /></div>
				</el-form-item>
				<p class="form-tip" style="margin-left: 200px;">请注意，实名是按责任人的信息去运营商匹配</p>
				<el-form-item label="所在地区" :rules="[{ required: true,message: '',trigger: 'blur'}]">
					<area-picker :areaData="areaData" @prvChange="prvChange" @cityChange="cityChange" @districtChange="districtChange" />
				</el-form-item>
				<el-form-item label="详细地址" prop="address">
					<el-input v-model="groupForm.address" autocomplete="off" />
				</el-form-item>
				<el-form-item label="座机电话" prop="tel">
					<el-input v-model="groupForm.tel" autocomplete="off" />
				</el-form-item>
				<el-form-item label="QQ号码">
					<el-input v-model="groupForm.qq" autocomplete="off" />
				</el-form-item>
				<el-form-item label="业务联系人" :rules="[{ required: true,message: '',trigger: 'blur'}]">
					<div v-if="!businessVisible">
						<div class="server" v-for="(item, index) in groupForm.businessContactPerson" :key="index">
							<el-input v-model="item.realName" placeholder="姓名" />
							<el-input v-model="item.mobile" placeholder="手机" />
							<el-input v-model="item.tel" placeholder="座机" />
							<el-button :icon="Minus" @click.prevent="removeBusiness(item)" v-if="index > 0"></el-button>
							<el-button :icon="Plus" @click="addBusiness" type="primary" v-if="index == 0"></el-button>
						</div>
					</div>
					<el-checkbox v-model="businessVisible" label="同责任人" />
				</el-form-item>
				<el-form-item label="技术负责人" :rules="[{ required: true,message: '',trigger: 'blur'}]">
					<div v-if="!techVisible">
						<div class="server" v-for="(item, index) in groupForm.technicalDirector" :key="index">
							<el-input v-model="item.realName" placeholder="姓名" />
							<el-input v-model="item.mobile" placeholder="手机" />
							<el-input v-model="item.tel" placeholder="座机" />
							<el-button :icon="Minus" @click.prevent="removeTech(item)" v-if="index > 0"></el-button>
							<el-button :icon="Plus" @click="addTech" type="primary" v-if="index == 0"></el-button>
						</div>
					</div>
					<el-checkbox v-model="techVisible" label="同责任人" @change="techChange" />
				</el-form-item>
				<el-form-item label="企业银行账号" prop="authBankName">
					<el-input v-model="groupForm.authBankName" autocomplete="off" />
				</el-form-item>
				<el-form-item label="企业开户银行名称" prop="authBankNo">
					<el-input v-model="groupForm.authBankNo" autocomplete="off" />
				</el-form-item>
				<el-form-item>
					<el-button @click="btnBack">上一步</el-button>
					<el-button type="primary" @click="submitForm(ruleFormRef)">下一步</el-button>
				</el-form-item>
			</el-form>
			<div class="foot-warn" style="margin-top: 60px;">
				<h4 class="title">温馨提示：</h4>
				<div class="content">
					<p>1. 请确保企业名称、统一社会信用代码、企业法人姓名等信息完全正确，否则会认证失败</p>
					<p>2. 企业认证将以对公账户打款的方式进行，请您确保对公账户信息正确，否则会打款失败</p>
					<p>3. 认证审核通过后，请您提交正确的打款金额，输入打款金额连续错误3次后，自动审核失败，您需要重新提交资料进行审核</p>
					<p>4. 注册手机号必须属本人所有，请勿使用他人手机进行注册，否则认证会失败，如果非本人手机号码，请先修改手机号再进行实名认证,不支持手机号为 170开头的实名认证</p>
					<p>5. 请勿使用虚假信息认证，否则蓝队云有权注销您的实名认证申请</p>
					<p>6. 蓝队云会加密保存您的认证资料，绝不会泄露用户隐私，请放心认证</p>
					<p>7. 所填写资料仅用于实名认证，不会开通其他任何附加服务，蓝队云工作人员不会向您索要短信验证码，谨防上当</p>
				</div>
			</div>
		</div>
	</div>
</template>

<script setup>
	import { ref,reactive,onMounted} from 'vue';
	import { useRouter } from 'vue-router';
	import { authInfo,businesssave } from '@/api/auth';
	import { Plus,Minus } from '@element-plus/icons-vue';
	import sideNav from '../../components/sideNav.vue';
	import areaPicker from '../../components/areaPicker.vue';
	import { ElMessage } from 'element-plus';
	
	const router = useRouter();
	const pageTitle = 'account';
	const showFlag = ref(false);
	const businessStatus = ref('0');
	const authRemark = ref('');
	const prvObj = ref('');
	const cityObj = ref('');
	const districtObj = ref('');
	const prvId = ref(0);
	const cityId = ref(0);
	const districtId = ref(0);
	const prv = ref('');
	const city = ref('');
	const district = ref('');
	const areaData = ref([]);
	const mobile = ref('');
	const email = ref('');
	const companyName = ref('');
	const companyTrueName = ref('');
	const businessLicence = ref('');
	const checkQuestion = ref(false);
	const businessVisible = ref(false);
	const techVisible = ref(false);
	const formLabelWidth = ref('200px');
	const ruleFormRef = ref(null);
	const groupForm = ref(
		{
			IDCard:'',
			address:'',
			authBankName:'',
			authBankNo:'',
			qq:'',
			tel:'',
			businessContactPerson: [{
				id:0,
				isChooseUser: false,
				mobile: '',
				realName: '',
				tel: ''
			}], 
			technicalDirector: [{
				id:0,
				isChooseUser: false,
				mobile: '',
				realName: '',
				tel: ''
			}]
		}
	)
	const rules = reactive({
		IDCard: [
			{ required: true, message: '请填写企业名称', trigger: 'blur' }
		],
		address: [
			{ required: true, message: '请填写详细地址', trigger: 'blur' }
		],
		authBankName: [
			{ required: true, message: '请填写企业银行账号', trigger: 'blur' }
		],
		authBankNo: [
			{ required: true, message: '请填写企业开户银行名称', trigger: 'blur' }
		],
		tel: [
			{ required: true, message: '请填写座机电话', trigger: 'blur' }
		]
	});
	
	const generData = () => {
		authInfo().then((res) => {
			if(res.code === 200){
				if (res.data.authStatus == '1' && res.data.authType == '2') {
					router.push({ path: '/verify/success' })
				}
				if (res.data.businessStatus == '2') {
					router.push({ path: '/verify/audit' })
				}else if(res.data.businessStatus == '4'){
					router.push({ path: '/verify/check' })
				}else{
					groupForm.value.IDCard = res.data.IDCard;
					groupForm.value.address = res.data.address;
					groupForm.value.authBankName = res.data.authBankName;
					groupForm.value.authBankNo = res.data.authBankNo;
					groupForm.value.qq = res.data.qq;
					groupForm.value.tel = res.data.businessTel;
					groupForm.value.IDCardImgFrontUrl = res.data.IDCardImgFrontUrl;
					groupForm.value.businessLicenceImgUrl = res.data.businessLicenceImgUrl;
					if (res.data.businessContactPerson.length > 0) {
						groupForm.value.businessContactPerson = res.data.businessContactPerson;
					}
					if (res.data.technicalDirector.length > 0) {
						groupForm.value.technicalDirector = res.data.technicalDirector;
					}
					if (res.data.prvId !== 0) {
						areaData.value.push(
							{ key: res.data.prvId.toString(), value: res.data.prv },
							{ key: res.data.cityId.toString(), value: res.data.city },
							{ key: res.data.districtId.toString(), value: res.data.district }
						);
					}
					prvId.value = res.data.prvId;
					cityId.value = res.data.cityId;
					districtId.value = res.data.districtId;
					prv.value = res.data.prv;
					city.value = res.data.city;
					district.value = res.data.district;
					authRemark.value = res.data.authRemark;
					businessStatus.value = res.data.businessStatus;
					mobile.value = res.data.mobileEncrypt;
					email.value = res.data.emailEncrypt;
					companyName.value = res.data.companyName;
					businessLicence.value = res.data.businessLicence;
					companyTrueName.value = res.data.companyTrueName;
					checkQuestion.value = res.data.checkQuestion;
					showFlag.value = true;
				}
			}
		})
	};
	const addBusiness = () => {
		groupForm.value.businessContactPerson.push({
			id:0,
			isChooseUser: false,
			mobile: '',
			realName: '',
			tel: ''
		})
	}
	const removeBusiness = (item) => {
		const index = groupForm.value.businessContactPerson.indexOf(item)
		if (index !== -1) {
			groupForm.value.businessContactPerson.splice(index, 1)
		}
	}
	const addTech = () => {
		groupForm.value.technicalDirector.push({
			id:0,
			isChooseUser: false,
			mobile: '',
			realName: '',
			tel: ''
		})
	}
	const removeTech = (item) => {
		const index = groupForm.value.technicalDirector.indexOf(item)
		if (index !== -1) {
			groupForm.value.technicalDirector.splice(index, 1)
		}
	}
	const prvChange = (val) =>{
		prvObj.value = val
	};
	const cityChange = (val) =>{
		cityObj.value = val
	};
	const districtChange = (val) =>{
		districtObj.value = val
	};
	const submitForm = () => {
	  if (!ruleFormRef.value) return;
	  ruleFormRef.value.validate((valid) => {
	    if (valid) {
			if (businessVisible.value) {
				groupForm.value.businessContactPerson = [{
					id:0,
					isChooseUser: true,
					mobile: '',
					realName: '',
					tel: ''
				}]				
			}else{
				if (checkArrayField(groupForm.value.businessContactPerson)) {
					ElMessage({
						offset: window.screen.height / 3,
						message: '请填写业务联系人信息',
						type: 'warning'
					})
					return
				}
			}
			if (techVisible.value) {
				groupForm.value.technicalDirector = [{
					id:0,
					isChooseUser: true,
					mobile: '',
					realName: '',
					tel: ''
				}]
			}else{
				if (checkArrayField(groupForm.value.technicalDirector)) {
					ElMessage({
						offset: window.screen.height / 3,
						message: '请填写技术负责人信息',
						type: 'warning'
					})
					return
				}
			}
			const param = groupForm.value;
			param['prvId'] = prvObj.value == '' ? prvId.value : parseInt(prvObj.value.key);
			param['cityId'] = cityObj.value == '' ? cityId.value : parseInt(cityObj.value.key);
			param['districtId'] = districtObj.value == '' ? districtId.value : parseInt(districtObj.value.key);
			param['prv'] = prvObj.value == '' ? prv.value : prvObj.value.value;
			param['city'] = cityObj.value == '' ? city.value : cityObj.value.value;
			param['district'] = districtObj.value == '' ? district.value : districtObj.value.value;
			businesssave(param).then((res) => {
				if(res.code === 200){
					ElMessage({
						offset:70,
						message: res.msg,
						type: 'success'
					})
					router.push({ path: '/verify/audit' })
				}
			})
	    } else {
	      return false;
	    }
	  });
	};
	const btnBack = () => {
		router.push({ path: '/verify/business' })
	};
	const checkArrayField = (arr) => {
		for (const item of arr) {
			if (!item.realName.trim() || !item.mobile.trim()) {
				return true;
			}
		}
		return false;
	}
	
	
	onMounted(() => {
		generData()
	})
	
</script>

<style lang="scss" scoped>
	.server{
		margin:2px 0;
		.el-input{width: 28.5% !important; margin-right: 1%;}
	}
</style>